import { render, staticRenderFns } from "./WinnerScreen.vue?vue&type=template&id=1b459fd0&"
import script from "./WinnerScreen.vue?vue&type=script&lang=js&"
export * from "./WinnerScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports